import { Box, Toolbar } from '@mui/material'
import Sidebar from 'components/common/Sidebar/SidebarLayout'
import sizeConfigs from 'configs/sizeConfigs'
import { useMobileResponsive } from 'hooks/useMobileResponsive'
import React, { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Topbar from './Topbar'
const CustomerLayout = () => {
    const [open, setOpen] = useState(false);
    const {isMobile}=useMobileResponsive()
    const handleDrawerToggle = () => {
        setOpen(!open);
        };
    const location = useLocation()
    const isLanding = location.pathname==='/'
  return (
      <Box>
        {!isLanding && <Topbar customer={isLanding} isMobile={isMobile} handleDrawerToggle={handleDrawerToggle} />}

          <Box
              component="nav"
              sx={{
                  width: sizeConfigs.sidebar.width,
                  flexShrink: 0
              }}
          >
              <Sidebar customer={isLanding} open={open} handleDrawerToggle={handleDrawerToggle} isMobile={isMobile} />
          </Box>
          <Box
              component="main"
              sx={{
                  flexGrow: 1,
                  p: location.pathname === '/customer/dashboard' || location.pathname === '/' ? 0 : 3,
                  width: (isMobile || isLanding || !location.pathname==='/')?'none':`calc(100% - 330px)`,
                  minHeight: "100vh",
                  float:(!isMobile && location.pathname!=='/') ? 'right':'none',
                //   backgroundColor: colorConfigs.mainBg
              }}
          >
              {!isLanding && <Toolbar />}
              <Outlet />
          </Box>
      </Box>
  )
}

export default CustomerLayout